import { useState } from "react";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";

const PrintButton = ({ search, endDateFilter, discountType }) => {
  const [loading, setLoading] = useState(false);

  const handlePrint = () => {
    const params = {
      search,
      statusFilter: endDateFilter ? endDateFilter.length === 1 ? endDateFilter[0] : null : null,
      discountType,
    }

    setLoading(true);
    axiosInstance
      .get("/discounts/print", {
        params,
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error printing:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      type="primary"
      size="large"
      icon={<PrinterOutlined />}
      loading={loading}
      onClick={handlePrint}
    >
      Print
    </Button>
  )
};

export default PrintButton;